var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBonusShopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.844H13.75v-.469a3.75 3.75 0 00-7.5 0v.469H3.156L2.5 19.375h15.063l-.688-14.531zM10 10.894a2.5 2.5 0 002.5-2.5V7.3h1.25v1.094a3.75 3.75 0 01-7.5 0V7.3H7.5v1.094a2.5 2.5 0 002.5 2.5zM7.5 4.375a2.5 2.5 0 115 0v.469h-5v-.469z",
    fill: "#9A9CAC"
  })));
}

export default SvgBonusShopIcon;